import { render } from "./Results9.vue?vue&type=template&id=68cb730c&scoped=true"
import script from "./Results9.vue?vue&type=script&lang=js"
export * from "./Results9.vue?vue&type=script&lang=js"

import "./Results9.vue?vue&type=style&index=0&id=68cb730c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cb730c"]])

export default __exports__